exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js??ref--6-1!./section.style.css"), undefined);

// module
exports.push([module.id, ".src-source-forms-sections-subsection-footer-style__root {\n}\n\n.src-source-forms-sections-subsection-footer-style__link {\n}\n", ""]);

// exports
exports.locals = {
	"root": "src-source-forms-sections-subsection-footer-style__root " + require("-!../../../node_modules/css-loader/index.js??ref--6-1!./section.style.css").locals["sectionFooter"] + "",
	"link": "src-source-forms-sections-subsection-footer-style__link " + require("-!../../../node_modules/css-loader/index.js??ref--6-1!./section.style.css").locals["footerButton"] + ""
};